import add from '../add.png';
import convert_icon from '../convert_icon.png';
import download from '../download.png';
import convert_icon_white from '../convert_icon_white.png';
import file from '../file.png';
import ConvertFrom from "./ConvertFrom";
import Resizer from "react-image-file-resizer";
import { Loader2 } from "lucide-react";

import {useState} from "react";
import React, {useRef}  from "react";
import ConvertTo from "./ConvertTo";

function ConvertSection(props) {

    const [showBox, setShowBox] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleClick = () => {
        setShowBox(true); // show component
    };

    const fileInputRef = useRef();
    const handleButtonClick = () => {
        console.log("button clicked")

        fileInputRef.current.click(); // open file dialog
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const fileName = file.name;
        const ext = fileName.split(".")[1];

        function popup () {

        }

        if (ext !== (props.convertFrom.toLowerCase())){
            popup();
            setSelectedFile(null);
            return;
        }


        setSelectedFile(file);
        if(file){

            handleClick();
        }
    };

    const handelenull  = (res) => {
        if (res !== "file"){
            setSelectedFile(null);
        }
    };


    return (
        <>
            <style>{`
            
                .btn-container{
                    width: 100%;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                
                .select-file-btn {
                    display: flex;
                    background: #B53836;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    gap: 15px;
                    padding: 10px;
                    width: 200px;
                    height: 55px;
                }
                .add-image-icon{
                    height: 23px;
                    place-items: center;
                }
                
                .select-text{
                    color: white;
                    font-weight: bold;
                }
            `}</style>


            <div
                className="btn-container"
                style={{ display: selectedFile ? "none" : "flex" }}
            >
                <div className="select-file-btn" onClick={handleButtonClick}>
                    <img src={add} className="add-image-icon" alt="add icon" />
                    <div className="select-text">Select File</div>
                </div>

                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
            </div>



            <div style={{ display: selectedFile ? "block" : "none" }}>
                <MyComponent file={selectedFile ? selectedFile : "file"} filetype={props.foramtType} onFormatChange = {props.onFormatChange}  set={handelenull} />
            </div>

        </>

    );
}

function MyComponent(props) {

    const styles = {
        // MAIN 50/50 SCREEN WRAPPER
        mainWrapper: {
            display: "flex",
            width: "100%",
            height: "100vh",
            overflow: "hidden",
        },

        // LEFT SIDE (Image Area)
        leftImageContainer: {
            flex: 1,
            background: "#e6e6e6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
        },

        imagePreview: {
            width: "100%",
            height: "auto",
            borderRadius: "10px",
            objectFit: "contain",
        },

        // RIGHT SIDE (Your UI Area)
        rightUIContainer: {
            flex: 1,
            overflowY: "auto",
            background: "#fff",
        },

        // -------- Your Existing Styles (unchanged) --------

        wrapper: {
            width: "100%",
        },

        container: {
            width: "95%",
            height: "70px",
            background: "#f1f1f1",
            borderRadius: "10px",
            margin: "40px auto",
            padding: "10px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
        },

        left: {
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
        },

        right: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
        },

        fileIcon: {
            width: "20px",
        },

        fileName: {
            fontSize: "18px",
        },

        icon: {
            fontSize: "20px",
        },

        text: {
            fontSize: "16px",
        },

        closeBtn: {
            marginLeft: "auto",
            border: "none",
            background: "transparent",
            fontSize: "20px",
            cursor: "pointer",
        },

        bottomBtnContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "30px",
        },

        bottomBtn: {
            padding: "10px 20px",
            background: "#008080",
            color: "white",
            fontSize: "16px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
        },
    };
    const _file =  props.file;
    const fileType = props.filetype
    var fileName = "File name";
    if(_file !== "file"){
        fileName = _file.name;
    }
    let imageURL = file

    if (!(_file === "file" || _file ==  null)){
        imageURL = URL.createObjectURL(_file);
    }





    const handleButtonClick = () => {
        console.log("button clicked")
        convertImage(_file,fileType);
        props.set(null);
        setConverted(false);

    };
    const handleFormatChange = (format) => {
        console.log("Selected format:", format);
        props.onFormatChange(format)
        // You can call convert function here
    };
    let fn = "file";

    if (props.file !== "file") {
        fn = null;
    }
    const [converted, setConverted] = useState(false);



    return (
        <div style={{
            display: "flex",
            width: "100%",
            height: "50vh",     // LEFT + RIGHT = HALF SCREEN
        }}>

        {/* LEFT SIDE IMAGE */}
            <div style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "10px"
            }}>
                <img
                    src={imageURL}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",   // SAME SIZE ALWAYS
                        borderRadius: "10px"
                    }}
                    alt="preview"
                />
            </div>



            {/* RIGHT SIDE UI */}
            <div style={{
                flex: 1,
                overflowY: "auto"
            }}>


                <div style={styles.wrapper}>

                    <div style={styles.container}>
                        <div style={styles.left}>
                            <img src={file} style={styles.fileIcon} alt="file"/>
                            <span style={styles.fileName}>{fileName}</span>
                        </div>

                        <div style={styles.right}>
                            <img src={convert_icon} style={styles.fileIcon} alt="convert"/>
                            <span style={styles.text}>Convert to</span>
                            <ConvertTo onFormatChange={handleFormatChange} formatType={fileType}/>
                            <button style={styles.closeBtn} onClick={() => props.set(fn)}>✖</button>
                        </div>
                    </div>


                    <div style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingRight: "30px",
                        gap: "10px"
                    }}>
                        {converted &&
                            <div className="select-file-btn" onClick={handleButtonClick}>
                                <img src={download} className="add-image-icon" alt="download" />
                                <div className="select-text">Download</div>
                            </div>
                        }

                        <div className="select-file-btn" onClick={() => setConverted(true)}>
                            <img src={convert_icon_white} className="add-image-icon" alt="convert" />
                            <div className="select-text">Convert</div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    );
}


const convertImage = (file, format = "PNG") => {
    const outputFormat = format.toUpperCase(); // JPEG, PNG, WEBP

    Resizer.imageFileResizer(
        file,
        800,
        800,
        outputFormat,  // TRUE format conversion only works with base64 below
        100,
        0,
        (base64String) => {

            // Convert base64 → Blob in new selected format
            const byteString = atob(base64String.split(",")[1]);
            const mimeString = `image/${outputFormat.toLowerCase()}`;

            const arrayBuffer = new ArrayBuffer(byteString.length);
            const intArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                intArray[i] = byteString.charCodeAt(i);
            }

            const blob = new Blob([arrayBuffer], { type: mimeString });

            // Download as REAL converted format
            const link = document.createElement("a");
            const originalName = file.name.split(".")[0];

            link.download = `${originalName}.${outputFormat.toLowerCase()}`;
            link.href = URL.createObjectURL(blob);
            link.click();

            URL.revokeObjectURL(link.href);
        },
        "base64" // IMPORTANT: must use base64 for real conversion
    );
};



export default ConvertSection;